// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5674":"css/app.6769","7281":"css/admin-app.6769"}[chunkId] + ".css";
};